/***
 * Created on 2023/8/10
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import laytop_svg from '../../../static/img/utils/ic-laytop.svg';
import {useTranslation} from "react-i18next";
import {addDays, formatDate, formatTime} from "../../../service/datetime";
import { useUA } from 'use-ua-parser-js';
import {useMutation} from "@tanstack/react-query";
import {apiDelete} from "../../../service/api";
import DeleteAccessDialog from "./delete_access_dialog";
import {Tooltip} from "react-tooltip";


function LoginDeviceTableRow({fieldList, data}) {
    const today = new Date();
    const { t } = useTranslation();
    // const os = useUA(data.user_agent);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    // console.log(os);

    return (
        <div className="flex-table-row">
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[0].size}`}>
                <div className="comp-group-info">
                    <div className="group-info--img round-full">
                        {
                            addDays(new Date(data.last_login), 32) < today &&
                            <span className="sys-badge sys-badge--tiny sys-badge--warning -tp-5 -rp-5"></span>
                        }
                        <img src={laytop_svg} />
                    </div>
                    <div className="group-info--detail">
                        <div className="group-info--detail__main-text text-ellipsis">
                            {
                                data.display_device_name
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[1].size}`} data-label={fieldList[1].name}>
                <span className="cell-text">
                    {data?.name}
                </span>
            </div>
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[2].size}`} data-label={fieldList[2].name}>
                <span className="cell-text">{data?.app?.display_name}</span>
            </div>
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[3].size}`} data-label={fieldList[3].name}>
                <span className="cell-text">
                    {data.display_domain}
                </span>
            </div>
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[4].size}`} data-label={fieldList[4].name}>
                    <div className="cell-text">
                        <a href="#" data-tooltip-id={data._id} data-tooltip-content={`${t('@Based on IP:@')} ${data?.remote_ip}`}>{data?.location?.country ? data?.location?.country : t('@Unknown@')}</a>
                        <Tooltip id={data._id} />
                    </div>
                <div className="cell-text color-dark-gray">{formatDate(t, data.last_login, true)} {formatTime(data.last_login)}</div>
            </div>
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[5].size}`}>
                <button className="q-btn q-btn--default btn-small btn-rounded-full min-w-0 !pl-18 !pr-18 !color-red" onClick={()=>setShowDeleteDialog(true)}>{t('@Remove@')}</button>
            </div>

            {showDeleteDialog && <DeleteAccessDialog showModal={showDeleteDialog} closeModal={()=>setShowDeleteDialog(false)} metadata={data}/>}
        </div>
    );
}

export default LoginDeviceTableRow;